"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Hidden = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Hidden = function Hidden() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.854 1.182a.575.575 0 00-.84 0l-.635.636a.576.576 0 000 .84l3.118 3.144a11.59 11.59 0 00-4.425 5.616 1.2 1.2 0 00-.072.384c0 .127.024.254.072.372a12.772 12.772 0 0011.92 8.028 13.183 13.183 0 005.601-1.308l3.538 3.528a.576.576 0 00.84 0l.635-.636a.576.576 0 000-.84L2.854 1.182zm9.139 14.22a3.599 3.599 0 01-3.598-3.6 3.47 3.47 0 01.444-1.68l4.797 4.8a3.466 3.466 0 01-1.643.48zM8.539 3.894c6.322-1.834 13.004 1.43 15.446 7.548.02.119.02.24 0 .36a.971.971 0 01-.072.396 11.292 11.292 0 01-2.794 4.284L8.54 3.894z",
    clipRule: "evenodd"
  });
};

exports.Hidden = Hidden;